export type RoomBookingBillingResult = {
  receiptId?: string;
  credit?: {
    invoiceId: string;
    paidAmount: number;
    remainingAmount: number;
  };
};

export type RoomBookingSuccessSearch = {
  bookingId: string;
  settlementMode?: "receipt" | "credit";
  receiptId?: string;
  creditInvoiceId?: string;
  creditPaid?: string;
  creditRemaining?: string;
};

export function buildRoomBookingSuccessSearch(
  bookingId: string,
  result: RoomBookingBillingResult,
): RoomBookingSuccessSearch | null {
  if (result.credit) {
    return {
      bookingId,
      settlementMode: "credit",
      creditInvoiceId: result.credit.invoiceId,
      creditPaid: String(result.credit.paidAmount),
      creditRemaining: String(result.credit.remainingAmount),
    };
  }
  if (result.receiptId) {
    return {
      bookingId,
      settlementMode: "receipt",
      receiptId: result.receiptId,
    };
  }
  return null;
}
